import React from 'react'
import Manager from 'tyan/public/components/Manager'
import { showExport } from '../../public/components/FileImpExp'
import InstrumentCatalogDiv from './InstrumentCatalogDiv'
import InstrumentDetail from './InstrumentDetail'
import InstrumentSetDuty from './InstrumentSetDuty'
import { exportFile } from 'tyan/public/index'
import { result } from 'lodash'

Ext.require('Ext.Toast')

const categories = {
    countWidth: '6em',
    width: 354,
    onDoubleTap: (that, data, record, grid) => {
        data.depth > 1 && Tyan.pubForm.showDialog('设备分类信息', props => <InstrumentCatalogDiv {...props} id={data.id} onRefresh={that.refresh} />)
    },
    contextmenu: [
        {
            _button: '添加分类...', btnName: '目录',
            handler: (that, data, record, grid) => {
                Tyan.pubForm.showDialog('设备分类信息', props => <InstrumentCatalogDiv {...props} id={0} fatherID={data.id} onRefresh={that.refresh} />)
            },
        },
        {
            _button: '添加设备...',
            hidden: data => data.depth == 1,
            handler: (that, data, record, grid) => {
                that.showDetail(props => <InstrumentDetail {...props} showDetail={that.showDetail} id={0} fatherID={data.id} />)
            },
        },
        {
            _button: '属性...', btnName: '详情',
            hidden: data => data.depth == 1,
            handler: (that, data, record, grid) => {
                Tyan.pubForm.showDialog('设备分类信息', props => <InstrumentCatalogDiv {...props} id={data.id} onRefresh={that.refresh} />)
            },
        },
    ],
}
const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length
const handleBatchAction = (result, { showDetail, refreshPage, state: { selected } }) => {
    const list = selected && selected.map(o => o.data.id) || []

    Tyan.doPostEvent('PrintCode', {
        data: { list },
        onEnd: ({ errorMessage, FID }) => {
            if (errorMessage) {
                Tyan.pubForm.showError(errorMessage)
            } else {
                exportFile(null, null, "GetFile?FID=" + FID)
            }
        }
    })
}

// const handleBatchExport = (result, { showDetail, refreshPage, state: { list: selected } }) => {
//     const list = selected && selected.map(o => o.id) || []
//     console.log('list',list)
//     //Tyan.pubForm.showExport({ event: 'ExportDevice', eventData: { list }, title: '设备信息导出', open: true })
// }

// const handleBatchExport = (that) => {
//     Tyan.pubForm.showExport({ event: 'ExportDevice', eventData: { searchValue: that.dataCond.searchValue }, title: '设备信息导出', open: true })
// }

const config = {
    tabs: {
        '设备管理': {
            multiSelect: true,
            buttons: [
                { text: '添加...', handler: ({ showDetail, category: { id: fatherID } = {} }) => showDetail(props => <InstrumentDetail {...props} showDetail={showDetail} id={0} fatherID={fatherID} />) },
                //{ text: '导出...', handler: ({ }) => Tyan.pubForm.showExport({ event: 'ExportDevice', eventData: { }, title: '设备信息导出', open: true }) },
                // {
                //     icon: '', text: '导出...',                                                          
                //     handler: that => handleBatchExport(that)
                // },
                {
                    text: '批量设置设备责任人', icon: '', handler: ({ showDetail, refreshPage, state: { selected } }) => {
                    const ids = selected && selected.map(o => o.data.id) || []
                    Tyan.pubForm.showDialog('批量设置设备责任人', props => <InstrumentSetDuty {...props} ids={ids} onSave={refreshPage} />)
                    }, disabled: ({ state: { selected = null } }) => !selected || !selected.length
                },
                {
                    icon: '', text: '批量打印二维码', disabled: disableBatch,
                    handler: that => handleBatchAction('打印', that),
                },
            ],
            export:true,
            exportColumns:[
                { _text: '设备编号', field: 'InstrumentNumber', flex: 1, search: true },
                { _text: '设备名称', field: 'InstrumentName', flex: 1, search: true },
                { _text: '设备英文名称', field: 'F14', flex: 1, search: true },
                { _text: '设备型号', field: 'F1', flex: 1, search: true },
                { _text: '存放位置', field: 'F4', flex: 1, search: true },
                { _text: '设备尺寸mm(长×宽×高）', field: 'InstrumentSize', flex: 1, search: true },
                { _text: '设备功率（KW）', field: 'F7', flex: 1, search: true },
                { _text: '冷却液需求', field: 'CoolantRequirement', flex: 1, search: true },
                { _text: '设备分类', field: 'FullFatherName', flex: 1, search: true },
                { _text: '瓶颈设备', field: 'F21', flex: 1, search: true },
                { _text: '设备状态', field: 'StatusName', flex: 1, search: true },
                { _text: '试验类型', field: 'F6', flex: 1, search: true },
                { _text: '主要功能', field: 'F3', flex: 1, search: true },
                { _text: '技术指标', field: 'F5', flex: 1, search: true },
                { _text: '测量范围', field: 'F20', flex: 1, search: true },
								{ _text: '分辨率', field: 'F19', flex: 1, search: true },
								{ _date: '计量有效日期', field: 'AdjustEffectiveDate', minWidth: 150, filter: true, },
                { _date: '下次计量日期', field: 'NextAdjustDate', minWidth: 150, filter: true, },
                { _text: '设备责任人', field: 'InstrumentManager', flex: 1, search: true },
                { _text: '设备对接人员', field: 'InstrumentDockingPerson', flex: 1, search: true },
                { _text: '设备厂商', field: 'F0', flex: 1, search: true },
                { _text: '厂商联系人', field: 'F10', flex: 1, search: true },
                { _text: '厂商电话', field: 'F11', flex: 1, search: true },
                { _text: '厂商邮箱', field: 'F13', flex: 1, search: true },
                { _date: '验收日期', field: 'F8', flex: 1, search: true },
                { _date: '开始使用日期', field: 'StartDate', flex: 1, search: true },
                { _text: '出厂编号', field: 'AppearanceNumber', flex: 1, search: true },
                { _text: '设备类型', field: 'CombType', flex: 1, search: true },
                { _text: '备注', field: 'F9', flex: 1, search: true },
                { _text: '是否排工设备', field: 'PlanInstrument', flex: 1, search: true },
                { _text: '每天工作时段', field: 'DayWorkTimes', flex: 1, search: true },
                { _text: '每天工作时长', field: 'DayWorkLength', flex: 1, search: true },
                { _text: '每周工作方式', field: 'WeekWrokMode', flex: 1, search: true },
                { _text: '每周工作时间', field: 'WeekWorkTimes', flex: 1, search: true },
                { _text: '节假日是否工作', field: 'IsWorkHolidays', flex: 1, search: true },
                { _text: '加班日是否工作', field: 'IsWorkOvertime', flex: 1, search: true },
                
            ],
            columns: [
                { _text: '设备编号', field: 'InstrumentNumber', locked: false, minWidth: 150, search: true, },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _date: '计量有效日期', field: 'AdjustEffectiveDate', minWidth: 150, filter: true, },
                { _date: '下次计量日期', field: 'NextAdjustDate', minWidth: 150, filter: true, },
                { _text: '设备型号', field: 'F1', minWidth: 120, filter: true, },
                { _text: '试验类型', field: 'F6', minWidth: 120, filter: true, },
                { _date: '验收日期', field: 'F8', minWidth: 120, filter: true, },
                { _text: '瓶颈设备', field: 'F21', minWidth: 120, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentDetail {...props} showDetail={showDetail} id={data.id} fatherID={0} />),
            categories,
        },
        '预警': {
            buttons: [
            ],
            columns: [
                { _text: '设备编号', field: 'InstrumentNumber', locked: false, minWidth: 150, search: true, },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _date: '计量有效日期', field: 'AdjustEffectiveDate', minWidth: 150, filter: true, },
                { _date: '期间核查有效日期', field: 'CheckEffectiveDate', minWidth: 170, filter: true, },
                { _date: '保养有效日期', field: 'MaintainEffectiveDate', minWidth: 150, filter: true, },
                { _text: '设备型号', field: 'F1', minWidth: 120, filter: true, },
                { _text: '试验类型', field: 'F6', minWidth: 120, filter: true, },
                { _date: '验收日期', field: 'F8', minWidth: 120, filter: true, },
                { _text: '瓶颈设备', field: 'F21', minWidth: 120, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentDetail {...props} showDetail={showDetail} id={data.id} fatherID={0} />),
            categories,
        },
        '超期': {
            buttons: [
            ],
            columns: [
                { _text: '设备编号', field: 'InstrumentNumber', locked: false, minWidth: 150, search: true, },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _date: '计量有效日期', field: 'AdjustEffectiveDate', minWidth: 150, filter: true, },
                { _date: '期间核查有效日期', field: 'CheckEffectiveDate', minWidth: 170, filter: true, },
                { _date: '保养有效日期', field: 'MaintainEffectiveDate', minWidth: 150, filter: true, },
                { _text: '设备型号', field: 'F1', minWidth: 120, filter: true, },
                { _text: '试验类型', field: 'F6', minWidth: 120, filter: true, },
                { _date: '验收日期', field: 'F8', minWidth: 120, filter: true, },
                { _text: '瓶颈设备', field: 'F21', minWidth: 120, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentDetail {...props} showDetail={showDetail} id={data.id} fatherID={0} />),
            categories,
        },
        '维护': {
            buttons: [
            ],
            columns: [
                { _text: '设备编号', field: 'InstrumentNumber', locked: false, minWidth: 150, search: true, },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _date: '计量有效日期', field: 'AdjustEffectiveDate', minWidth: 150, filter: true, },
                { _date: '期间核查有效日期', field: 'CheckEffectiveDate', minWidth: 170, filter: true, },
                { _date: '保养有效日期', field: 'MaintainEffectiveDate', minWidth: 150, filter: true, },
                { _text: '设备型号', field: 'F1', minWidth: 120, filter: true, },
                { _text: '试验类型', field: 'F6', minWidth: 120, filter: true, },
                { _date: '验收日期', field: 'F8', minWidth: 120, filter: true, },
                { _text: '瓶颈设备', field: 'F21', minWidth: 120, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentDetail {...props} showDetail={showDetail} id={data.id} fatherID={0} />),
            categories,
        },
        '停用': {
            buttons: [
            ],
            columns: [
                { _text: '设备编号', field: 'InstrumentNumber', locked: false, minWidth: 150, search: true, },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _date: '计量有效日期', field: 'AdjustEffectiveDate', minWidth: 150, filter: true, },
                { _date: '期间核查有效日期', field: 'CheckEffectiveDate', minWidth: 170, filter: true, },
                { _date: '保养有效日期', field: 'MaintainEffectiveDate', minWidth: 150, filter: true, },
                { _text: '设备型号', field: 'F1', minWidth: 120, filter: true, },
                { _text: '试验类型', field: 'F6', minWidth: 120, filter: true, },
                { _date: '验收日期', field: 'F8', minWidth: 120, filter: true, },
                { _text: '瓶颈设备', field: 'F21', minWidth: 120, filter: true, },
                { _date: '停用日期', field: 'LastStopDate', minWidth: 120, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentDetail {...props} showDetail={showDetail} id={data.id} fatherID={0} />),
            categories,
        },
        '报废': {
            buttons: [
            ],
            columns: [
                { _text: '设备编号', field: 'InstrumentNumber', locked: false, minWidth: 150, search: true, },
                { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 1, search: true, },
                { _date: '计量有效日期', field: 'AdjustEffectiveDate', minWidth: 150, filter: true, },
                { _date: '期间核查有效日期', field: 'CheckEffectiveDate', minWidth: 170, filter: true, },
                { _date: '保养有效日期', field: 'MaintainEffectiveDate', minWidth: 150, filter: true, },
                { _text: '设备型号', field: 'F1', minWidth: 120, filter: true, },
                { _text: '试验类型', field: 'F6', minWidth: 120, filter: true, },
                { _date: '验收日期', field: 'F8', minWidth: 120, filter: true, },
                { _text: '瓶颈设备', field: 'F21', minWidth: 120, filter: true, },
                { _date: '报废日期', field: 'LastScrapDate', minWidth: 120, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <InstrumentDetail {...props} showDetail={showDetail} id={data.id} fatherID={0} />),
            categories,
        },
    },
}

export default props => <Manager {...props} config={config} />